import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { OffersService } from '../../../../shared/services/admServices/offers.service';
import { Offer, OfferEdit, OfferStatus } from '../../../../models/admModel/offer.model';

@Component({
  selector: 'pub-campdetails-component',
  templateUrl: './offer-details-component.html',
  styleUrls: ['./offer-details-component.scss']
})

export class offerDetailsComponent implements OnInit {
  btnStatus: any;
  btnColor: any;
  //offerData: any;
  offer = new Offer();
  status = new OfferStatus();
  offerEdit = new OfferEdit();

  constructor(private route: ActivatedRoute,
    private router: Router,
    private toastrService: ToastrService,
    private offersService: OffersService,
    ) {
    }

  ngOnInit() {
    this.getOffer(this.route.snapshot.params?.['id']);
   }

  getOffer(id: string): void {
    this.offersService.getOffer(id)
    .subscribe(
     data => {
      this.offerEdit.offerCap = data.data.cap;
      this.offerEdit.offerLockingDescription = data.data.offerLockingDescription;
      this.offerEdit.offerLockingTitle = data.data.offerLockingTitle;
      this.offerEdit.offerName = data.data.offerName;

      this.offer.offerName = data.data.offerName;
      this.offer.offerId = data.data.offerId;
      this.offer.advertiserOfferId = data.data.advertiserOfferId;
      this.offer.offerGlobalStatus = data.data.status.globalStatus;
      this.offer.offerPublisherStatus = data.data.status.publisherStatus;
      this.offer.payout = data.data.payout;
      this.offer.advertisername = data.data.advertiser.name;
      this.offer.countryname = data.data.country.name;
      this.offer.countryalpha2Code = data.data.country.alpha2Code;
      this.offer.offerUrl = data.data.offerUrl;
      this.offer.offerPreviewUrl = data.data.offerPreviewUrl;
      this.offer.offerCategoryId = data.data.offerCategory.id;
      this.offer.offerDevices = data.data.offerDevices;
     },
     error => {
       console.log(error);
     });
  }

  onCancel(){
    this.router.navigate(['/adm/offers']);
  }

  onSave(){
    this.offersService.updateOffer(this.offer.offerId, this.offerEdit)
    .subscribe(
      data => {
        this.toastrService.success('Data for offer is saved.', 'Success !');
      },
      error => {
        console.log(error);
      });
  }

  onPreviewUrl(){
    window.open(this.offer.offerPreviewUrl, "_blank");
  }

  onUrl(){
    window.open(this.offer.offerUrl, "_blank");
  }

  onStatus(){
    if(this.offer.offerGlobalStatus=='Active')
    {
      this.status.statusId=3; // disabled
      this.offer.offerGlobalStatus='Disabled';

      this.offersService.updateOfferStatus(this.offer.offerId, this.status)
      .subscribe(
       () => {
        this.toastrService.success('Global offer status is changed.', 'Success !');
      },
       error => {
         console.log(error);
       });

    }
    else
    {
      this.status.statusId=1; // active
      this.offer.offerGlobalStatus='Active';

      this.offersService.updateOfferStatus(this.offer.offerId, this.status)
      .subscribe(
       () => {
        this.toastrService.success('Global offer status is changed.', 'Success !');
      },
       error => {
         console.log(error);
       });
    }
  }
}
